import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Button, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { getCustomerPaymentMethods } from "../../../../../services/customer";

import { useEffect, useState } from "react";
import { logging } from "../../../../../utils/functions";

import PaymentMethod, { Card, GooglePay, Paypal } from "../PaymentMethod";
import { gpay, master, momo, paypal, visa } from "../PaymentMethod/logos"

const paymentMethodOptionStyles = {
  borderRadius: 1, p: 1, cursor: 'pointer', border: '1px solid rgba(0, 0, 0, 0.23)'
}

const activeStyles = {
  bgcolor: grey[100],
}

function AddNewPaymentMethod({ customer, callback, setShowCreatePaymentMethod }: any) {
  const [method, setMethod] = useState<string | null>('MasterCard');

  useEffect(() => {
    logging('AddNewPaymentMethod', customer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Stack direction="row">
        <PaymentMethod url={master} active={method === 'MasterCard'} onClick={() => setMethod('MasterCard')} />
        <PaymentMethod url={visa} active={method === 'Visa'} onClick={() => setMethod('Visa')} />
        <PaymentMethod url={paypal} active={method === 'PayPalAccount'} onClick={() => setMethod('PayPalAccount')} width={70} />
        <PaymentMethod url={gpay} active={method === 'AndroidPayCard'} onClick={() => setMethod('AndroidPayCard')} />
        <PaymentMethod url={momo} active={method === 'MOMO'} onClick={() => setMethod('MOMO')} />
      </Stack>
      <Box sx={{ mb: 1 }}>
        {(method === 'Visa' || method === "MasterCard") && (<Card provider={method} callback={callback} />)}
        {method === 'PayPalAccount' && (<Paypal provider={method} callback={callback} />)}
        {method === 'AndroidPayCard' && (<GooglePay provider={method} callback={callback} />)}
      </Box>
      <Button fullWidth onClick={() => setShowCreatePaymentMethod(false)} sx={{ border: `1px solid ${grey[900]}`, bgcolor: 'transparent ! important' }}>
        <Typography fontSize={14} sx={{ color: grey[900] }}>Cancel</Typography>
      </Button>
    </>
  )
}

export default function PaymentMethodSelection({ customer, defaultSelect, onChange }: any) {
  const [isShowCreatePaymentMethod, setShowCreatePaymentMethod] = useState(false);

  const { data: methods } = getCustomerPaymentMethods(customer)

  async function handleSubmitPaymentMethod(payment: any) {
    if (payment?.nonce) {
      console.log(payment)
    }
  }

  useEffect(() => {
    logging('AccountBillingInvoice ▶ PaymentMethodSelection', methods)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {isShowCreatePaymentMethod ? (
        <AddNewPaymentMethod customer={customer} callback={handleSubmitPaymentMethod} setShowCreatePaymentMethod={setShowCreatePaymentMethod} />
      ) : (
        <>
          {methods?.lenght !== 0 ? (
            <Box sx={{ mb: 1 }}>
              {methods?.map((method: any, index: number) => {
                const active = defaultSelect?.type === method.type

                switch (method.type) {
                  case 'PayPalAccount':
                    return (
                      <Box key={index} sx={{ ...(active ? activeStyles : {}), ...paymentMethodOptionStyles }} onClick={() => onChange(method)}>
                        {active ? (<RadioButtonCheckedIcon />) : (<RadioButtonUncheckedIcon />)}
                        <Box sx={{ mt: -1 }}>
                          <Paypal method={method.type} state={method} validate={false} />
                        </Box>
                      </Box>
                    )
                  case 'AndroidPayCard':
                    return (
                      <Box key={index} sx={{ ...(active ? activeStyles : {}), ...paymentMethodOptionStyles }} onClick={() => onChange(method)}>
                        {active ? (<RadioButtonCheckedIcon />) : (<RadioButtonUncheckedIcon />)}
                        <GooglePay method={method.type} state={method} validate={false} />
                      </Box>
                    )
                  case 'Visa':
                  case 'MasterCard':
                    return (
                      <Box key={index} sx={{ ...(active ? activeStyles : {}), ...paymentMethodOptionStyles }} onClick={() => onChange(method)}>
                        {active ? (<RadioButtonCheckedIcon />) : (<RadioButtonUncheckedIcon />)}
                        <Card method={method.type} state={method} validate={false} />
                      </Box>
                    )
                  default:
                    return null
                }
              })}
            </Box>
          ) : (
            <Box sx={{ mb: 1 }}>
              <Typography fontSize={14}>No payment methods are currently associated with your account</Typography>
            </Box>
          )}
          <Box sx={{ my: 1, maxWidth: 400 }}>
            <Box sx={{ ...(defaultSelect?.type === 'BankTransfer' ? activeStyles : {}), ...paymentMethodOptionStyles }} onClick={() => onChange({ type: 'BankTransfer' })}>
              {defaultSelect?.type === 'BankTransfer' ? (<RadioButtonCheckedIcon />) : (<RadioButtonUncheckedIcon />)}
              <Box sx={{ mt: 1 }}>
                <Typography fontSize={14} fontWeight={700}>Bank Transfer</Typography>
                {defaultSelect?.type === 'BankTransfer' && (
                  <Box>
                    <Typography fontSize={13}>Receiver: VNETWORK Joint Stock Company</Typography>
                    <Typography fontSize={13}>Account Number: 19036996598018</Typography>
                    <Typography fontSize={13}>Bank Name: TECHCOMBANK</Typography>
                    <Typography fontSize={13}>Swift Code: VTCBVNVX</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          <Button fullWidth onClick={() => [setShowCreatePaymentMethod(true), onChange(null)]} sx={{ border: `1px solid ${grey[500]}`, bgcolor: 'transparent ! important', cursor: 'pointer' }}>
            <Typography fontSize={14} sx={{ color: grey[900] }}>Add new Payment Method</Typography>
          </Button>
        </>
      )}
    </>
  )
}